import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Icon } from '../../../../common/html/icon'

export const ShowAllIndustryCheckbox = ({ isShow, onClick }) => {
  return (
    <div className="dFlex gap1 alignItemsCenter">
      <Icon
        className={isShow ? 'icon-checkbox-check' : 'icon-checkbox-uncheck'}
        style={{ color: isShow ? '#2C73E8' : '#9C9C9C' }}
        onClick={() => onClick(!isShow)}
      />
      <span onClick={() => onClick(!isShow)} className="cursorPointer">
        <Translate value="industryOverview.macroeconomics.SHOW_DATA_INDUSTRIES" />
      </span>
    </div>
  )
}

ShowAllIndustryCheckbox.propTypes = {
  isShow: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
}

ShowAllIndustryCheckbox.defaultProps = {
  onClick: () => {},
}
